<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account-check-outline
      </v-icon> Mark Safe
    </h2>
    <br>
    <v-card
      class="my-base-vcard-style"
    >
      <v-card
        light
        class="my-vcard-style"
        :style="getBgStyle"
      >
        <v-container fluid>
          <div class="title-text">
            <v-icon
              size="100"
              color="#66BB6A"
            >
              mdi-check-all
            </v-icon>
            <p>
              Verify You Are Safe
            </p>
          </div>
          <p class="subtitle-text">
            Please mark your current status
          </p>
          <div class="pa-4 text-center">
            <v-row
              class="fill-height"
              align="center"
              justify="center"
            >
              <v-col
                cols="6"
                sm="3"
                md="3"
              >
                <v-card
                  id="type-card"
                  light
                  @click="clickSafe()"
                >
                  <div>
                    <v-icon
                      size="50"
                      light
                      color="#2E7D32"
                    >
                      mdi-emoticon-happy
                    </v-icon>
                    <p class="type-name">
                      SAFE
                    </p>
                  </div>
                </v-card>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                md="3"
              >
                <v-card
                  id="type-card"
                  light
                  @click="clickUnsafe()"
                >
                  <div>
                    <v-icon
                      size="50"
                      light
                      color="#C62828"
                    >
                      mdi-emoticon-sad
                    </v-icon>
                    <p class="type-name">
                      UNSAFE
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-container>
        <br>
      </v-card>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-container>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'AlertResponsePage',
  components: {
    'centre-spinner': spinner,
  },
  mixins: [global],
  data () {
    return {
      loading: false,
      cardBgImg: require('@/assets/img/cardBg.png'),
    };
  },
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
  },
  methods: {
    async clickSafe () {
      this.loading = true;
      const alertResponseId = this.$route.params.responseId;
      await this.$store.dispatch('alert/sendAlertResponse', {
        responseGiven: {
          response: 'safe',
        },
        responseId: alertResponseId,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Response send successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$router.push({ name: 'HomePage' });
      }).catch(() => {
        this.loading = false;
      });
    },
    async clickUnsafe () {
      this.loading = true;
      const alertResponseId = this.$route.params.responseId;
      await this.$store.dispatch('alert/sendAlertResponse', {
        responseGiven: {
          response: 'unsafe',
        },
        responseId: alertResponseId,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Response send successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$router.push({ name: 'HomePage' });
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.my-vcard-style {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.my-base-vcard-style {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #CFD8DC !important;
}
.title-text {
  color: #37474F;
  font-size: 30px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.subtitle-text {
  font-size: 20px;
  color: #546E7A;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.alert-text {
  color: #37474F;
  border-left: 3px solid #546E7A !important;
  border-right: 3px solid #546E7A !important;
  border-bottom: 3px solid #546E7A !important;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.type-name {
  font-size: 18px;
  font-weight: bold;
  color: #263238;
  font-family: 'Times New Roman', Times, serif;
  text-transform: capitalize;
}
#type-card {
  border-left: 3px solid #546E7A !important;
  border-right: 3px solid #546E7A !important;
  border-top: 3px solid #546E7A !important;
  padding-top: 10px;
}
</style>
